import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import cs from 'vuetify/es5/locale/cs'

Vue.use(Vuetify)

export default new Vuetify({
	lang: {
		locales: { cs },
		current: Vue.prototype.$cfg('locale')
	},
	icons: {
		iconfont: 'mdi' // default - only for display purposes
	}
})
